<div class="overflow-hidden space" id="case-study-sec">
    <div class="container-fuild">
        <div class="title-area mb-30 text-center">
            <span class="sub-title text-anime-style-2">Project Gallery</span>
            <h2 class="sec-title text-anime-style-3">Let’s See Our Recent Work Projects Gallery</h2>
        </div>
        <div class="row gy-4 case-row4">
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/mobile_app.png" alt="Web & Mobile Development" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">Web & Mobile Development</a>
                            </h4>
                            <span class="case-subtitle">Development</span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/animation-1.png" alt="UiUx Design" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">UiUx Design</a>
                            </h4>
                            <span class="case-subtitle">Design </span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/web_design.png" alt="Website Design" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">Website Design</a>
                            </h4>
                            <span class="case-subtitle">Management</span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/ecommerce-1.png" alt="WordPress Development" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">WordPress Development</a>
                            </h4>
                            <span class="case-subtitle">Project Analysis</span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/logo_design.png" alt="Logo Design" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">Logo Design</a>
                            </h4>
                            <span class="case-subtitle">Designer</span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/laravel.png" alt="Laravel Development" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">Laravel Development</a>
                            </h4>
                            <span class="case-subtitle">Development</span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/shopify.png" alt="Shopify Development" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">Shopify Development</a>
                            </h4>
                            <span class="case-subtitle">Development</span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="case-box style2 position-relative">
                    <div class="case-img global-img">
                        <img src="assets/img/project/nextjs.png" alt="NextJs Development" />
                        <a routerLink="/our-projects" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                    <div class="case-content">
                        <div class="media-left">
                            <h4 class="box-title">
                                <a routerLink="/our-projects">NextJs Development</a>
                            </h4>
                            <span class="case-subtitle">Development</span>
                        </div>
                    </div>
                    <div class="case-action">
                        <a routerLink="/our-projects" class="case-btn"><i class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>